import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        const resetScroll = () => {
            // Layout.jsx의 main-scroll-container를 최우선으로 초기화
            const mainContent = document.getElementById('main-scroll-container');
            if (mainContent) {
                mainContent.scrollTop = 0;
            }

            // 브라우저 기본 창 초기화 (백업)
            window.scrollTo(0, 0);
            if (document.documentElement) document.documentElement.scrollTop = 0;
            if (document.body) document.body.scrollTop = 0;
        };

        // 즉시 실행 및 아주 미세한 지연 실행 (렌더링 보장)
        resetScroll();
        const timeoutId = setTimeout(resetScroll, 0);

        return () => clearTimeout(timeoutId);
    }, [pathname, search]);

    return null;
};

export default ScrollToTop;
